// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext, useLayoutEffect, useRef} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {Media_block} from '../media_block';
import * as ui_links from '../ui_install_links';
import {On_view_animation} from '../on_view_animation';
import styles from './hp_media.module.less';
import {guess_os_and_version} from '../../client_hints_global';
import {guess_browser} from 'zuser_agent';

const Contrast_link = props=>{
    const {children, ...rest} = props;
    const ref = useRef<HTMLAnchorElement>();
    useLayoutEffect(()=>{
        if (!ref.current)
            return;
        ref.current.style.width = `${ref.current.offsetWidth}px`;
        ref.current.style.padding = '0';
    }, [ref]);
    return <a ref={ref} className={styles.contrast_link} target="_blank"
      rel="noopener noreferrer" {...rest}><span>{children}</span></a>;
};

export const HP_media = ()=>{
    const {theme} = useContext(Settings_context);
    const b = guess_browser();
    const store_link = ui_links[`${b.browser}_href`]||ui_links.chrome_href;
    const components = {
        Btn_free: <Contrast_link href={store_link}
          data-clickid="hp_media_btn_free"/>,
        Btn_premium: <Contrast_link href="/premium?ref=hp_media_title"
          data-clickid="hp_media_btn_premium"/>,
        Link_contribute: <a className={styles.text_link}
          href="/faq#intro-cost" data-clickid="hp_media_contribute"/>,
        Link_premium: <a className={styles.text_link}
          href="/premium?ref=hp_media_link" data-clickid="hp_media_premium"/>,
    };
    const anim_size = {all: [544, 444], sm: [335, 273], xs: [335, 273]};
    const anim_flashlight = <On_view_animation
      cls={cn(styles.animation, styles.animation_flashlight)}
      src="animation/hp_media_flashlight.json" size={anim_size} loop
    />;
    const anim_arc = <On_view_animation
      cls={cn(styles.animation, styles.animation_arc)}
      src="animation/hp_media_arc.json" size={anim_size} loop
    />;
    const sys = guess_os_and_version();
    // XXX dmitriyr: condition for alternative text isn't clear, need to fix
    const is_peer = ['windows', 'macos'].indexOf(sys.os)>=0;
    const free_text = `hp.media.free.text${is_peer ? '2' : ''}`;
    return <div className={cn(theme.container, theme.block)}>
      <Media_block img_content={anim_flashlight} title="hp.media.free.title"
        text={free_text} components={components}/>
      <Media_block img_content={anim_arc} title="hp.media.premium.title"
        text="hp.media.premium.text" components={components} reversed
        cls={{content: styles.premium_text}}/>
    </div>;
};
